// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2xV_w","colCheckbox":"styles_colCheckbox__2wwIK"};